<template>
    <div id="app">
      <div class="tl_page_wrap">
        <div class="tl_page">
          <main class="tl_article">
            <!-- 页面头部 -->
            <header class="tl_article_header" dir="auto">
              <h1>{{ pageTitle }}</h1>
              <address>
                <a rel="author" :href="authorLink" target="_blank">{{ authorName }}</a>
                <time :datetime="publishTime">{{ formattedDate }}</time>
              </address>
            </header>
  
            <!-- 文章内容 -->
            <article class="tl_article_content">
              <!-- 智能查询系统说明 -->
              <section class="system-intro">
                <h3>🔍 智能查询系统说明</h3>
                <ul>
                  <li>直接输入即可查询，系统自动分析查询内容</li>
                  <li>高级查询和综合查询均有极高全户出率</li>
                  <li>会员享受全部高级功能免费使用(除批量与奇思妙想)</li>
                </ul>
              </section>
  
              <!-- 基础查询功能 -->
              <BasicQuerySection></BasicQuerySection>
  
              <!-- 进阶模块功能 -->
              <advanced-modules-section></advanced-modules-section>
  
  
  
              <!-- 充值说明 -->
              <recharge-instructions></recharge-instructions>
  
       
  
              <!-- 使用技巧 -->
              <usage-tips></usage-tips>
  
              <!-- 邀请推广 -->
              <invitation-promotion></invitation-promotion>
            </article>
  
            <!-- 页脚操作按钮 -->
            <aside class="tl_article_buttons">
              <button class="button edit_button">Edit</button>
              <button class="button publish_button">Publish</button>
            </aside>
          </main>
        </div>
      </div>
  
      <!-- 报告弹出窗口 -->
      <report-popup v-if="showReportPopup"></report-popup>
    </div>
  </template>
  
  <script>
  import BasicQuerySection from './components/BasicQuerySection.vue';
  import AdvancedModulesSection from './components/AdvancedModulesSection.vue';
  import RechargeInstructions from './components/RechargeInstructions.vue';
  import InvitationPromotion from './components/InvitationPromotion.vue';
  import ReportPopup from './components/ReportPopup.vue';
  import UsageTips from './components/UsageTips.vue';
  
  export default {
    name: 'App',
    components: {
      BasicQuerySection,
      AdvancedModulesSection,
      RechargeInstructions,
      InvitationPromotion,
      ReportPopup,
      UsageTips
    },
    data() {
      return {
        pageTitle: '佐罗社工系统使用指南',
        authorName: '佐罗',
        authorLink: 'https://t.me/ZLCDRGKF_BOT',
        publishTime: '2024-12-30T13:14:36+0000',
        showReportPopup: false
      }
    },
    computed: {
      formattedDate() {
        const options = { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric'
        }
        return new Date(this.publishTime).toLocaleDateString('zh-CN', options)
      }
    }
  }
  </script>
  
  <style>
  /* 保留原始样式结构 */
  @import url('/css/quill.core.min.css');
  @import url('/css/core.min.css?47');
  
  /* 添加必要的基础样式 */
  .tl_page_wrap {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .tl_article_header {
    border-bottom: 1px solid #eee;
    margin-bottom: 2em;
    padding-bottom: 1em;
  }
  
  .tl_article_content {
    line-height: 1.8;
  }
  
  .tl_article_content h3 {
    margin: 1.5em 0 1em;
    padding-bottom: 0.5em;
    border-bottom: 2px solid #eee;
  }
  
  .tl_article_content h4 {
    margin: 1.2em 0 0.8em;
    color: #666;
  }
  
  .tl_article_content ul {
    padding-left: 1.5em;
    list-style-type: disc;
  }
  
  .button {
    background: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 5px;
  }
  
  .button:hover {
    background: #0056b3;
  }
  </style>